(function(){

    /*
    * Ottimizzazione riproduzione video in homepage con Logo in overlay riposizionato
    * */

    const vDesktop = document.getElementById('heroVideoDesktop');
    const vMobile  = document.getElementById('heroVideoMobile');
    const section  = document.querySelector('.hero-video');
    const logoImg  = document.querySelector('.hero-logo__img');

    // Sorgenti video: carichiamo solo quelle dell'istanza attiva
    const SRC = {
        desktop: [
            { src: '/wp-content/themes/melismelis/dist/assets/attachments/video/MM_Homepage_1920x1080.mp4', type: 'video/mp4' },
            { src: '/wp-content/themes/melismelis/dist/assets/attachments/video/MM_Homepage_1920x1080.webm', type: 'video/webm' },
        ],
        mobile: [
            { src: '/wp-content/themes/melismelis/dist/assets/attachments/video/MM_Homepage_1080x1920.mp4', type: 'video/mp4' },
            { src: '/wp-content/themes/melismelis/dist/assets/attachments/video/MM_Homepage_1080x1920.webm', type: 'video/webm' },
        ]
    };

    const mq = window.matchMedia('(max-width: 768px), (orientation: portrait)');
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setSources(videoEl, sources){
        if (!videoEl || videoEl.dataset.loaded === '1') return;
        sources.forEach(s=>{
            const el = document.createElement('source');
            el.src = s.src; el.type = s.type;
            videoEl.appendChild(el);
        });
        videoEl.dataset.loaded = '1';
    }

    function playSafely(videoEl){
        if (!videoEl) return;
        videoEl.muted = true;
        videoEl.setAttribute('playsinline','');
        videoEl.setAttribute('webkit-playsinline','');
        const p = videoEl.play();
        if (p && p.catch) p.catch(()=>{});
    }

    function activate(which){
        const active  = (which === 'mobile') ? vMobile : vDesktop;
        const passive = (which === 'mobile') ? vDesktop : vMobile;

        if (which === 'mobile') setSources(vMobile, SRC.mobile);
        else setSources(vDesktop, SRC.desktop);

        active.classList.add('is-active');
        passive.classList.remove('is-active');

        if (prefersReduced) { try{active.pause();}catch(e){} try{passive.pause();}catch(e){} }
        else { playSafely(active); try{passive.pause();}catch(e){} }
    }

    // —— OVERHANG RESPONSIVO ——
    // Mappa valori (in px) per fasce di larghezza (puoi affinare a occhio):
    // ≥1200: 69px  |  992–1199: 55px  |  768–991: 45px  |  480–767: 35px  |  <480: 28px
    function computeOverhangPx(w){
        if (w < 300)  return 15;
        if (w < 320)  return 16;
        if (w < 340)  return 17;
        if (w < 360)  return 18;
        if (w < 380)  return 19;
        if (w < 400)  return 20;
        if (w < 420)  return 22;
        if (w < 440)  return 23;
        if (w < 460)  return 24;
        if (w < 480)  return 25;
        if (w < 520)  return 26;
        if (w < 576)  return 28;
        if (w < 768)  return 30;
        if (w < 992)  return 38;
        if (w < 1200) return 50;
        if (w < 1400) return 60;
        return 69; // desktop base
    }

    let resizeRaf = null;
    function applyOverhang(){
        if (!section || !logoImg) return;
        const overhang = computeOverhangPx(window.innerWidth);
        section.style.setProperty('--overhang', overhang + 'px');
    }
    function onResize(){
        if (resizeRaf) return;
        resizeRaf = requestAnimationFrame(() => {
            resizeRaf = null;
            applyOverhang();
        });
    }

    // Inizializzazione
    activate(mq.matches ? 'mobile' : 'desktop');
    applyOverhang();

    // Listener
    mq.addEventListener('change', e => activate(e.matches ? 'mobile' : 'desktop'));
    window.addEventListener('pageshow', e => { if (e.persisted) activate(mq.matches ? 'mobile' : 'desktop'); });
    window.addEventListener('resize', onResize, { passive:true });

    // Se il logo non è ancora caricato, riallinea quando arriva
    if (logoImg && !logoImg.complete) {
        logoImg.addEventListener('load', applyOverhang, { once:true });
    }



    /*
    * Inizializzazione Swiper.js per news
    * */
    var swiper = new Swiper(".newsSwiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            "992": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            "1200": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
        },
    });



    /*
    * Allineamento voci H3 nella sezione "Cosa facciamo"
    * */
    const img = document.getElementById('wwd-video');
    const titlesWrap = document.getElementById('wwd-titles');

    if (!img || !titlesWrap) return;

    // funzione che sincronizza l’altezza dei titoli con quella dell’immagine
    function syncHeights() {
        // su mobile (ad es. <576px) puoi scegliere di non forzare l’altezza
        if (window.matchMedia('(max-width: 767.98px)').matches) {
            titlesWrap.style.height = '';
            return;
        }
        const h = img.clientHeight; // altezza renderizzata dell’immagine
        if (h > 0) titlesWrap.style.height = h + 'px';
    }

    // quando l’immagine è caricata
    if (img.complete) syncHeights();
    else img.addEventListener('load', syncHeights, { once: true });

    // osserva cambi di dimensione dell’immagine (responsive/video swap)
    if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(syncHeights);
        ro.observe(img);
    } else {
        // fallback
        window.addEventListener('resize', syncHeights);
        window.addEventListener('orientationchange', syncHeights);
    }



    /*
    * Effetto GSAP loghi clienti
    * */
    document.addEventListener("DOMContentLoaded", () => {
        const clientContainer = document.querySelector(".client-grid");
        if (!clientContainer) return;

        // Match del tuo controllo: windowWidth > 480
        //if (window.innerWidth <= 575) return;

        const clients = clientContainer.querySelectorAll(".client");

        // Imposto l'indice per lo stagger via CSS var --i
        clients.forEach((el, i) => el.style.setProperty("--i", i));

        const io = new IntersectionObserver(
            (entries) => {
                for (const entry of entries) {
                    if (!entry.isIntersecting) continue;

                    clientContainer.classList.add("is-inview");

                    // once: true
                    io.unobserve(entry.target);
                }
            },
            {
                // equivalente a "start: top center" circa:
                // scatta quando il top del container entra nella metà viewport
                root: null,
                threshold: 0,
                rootMargin: "-80% 0px -20% 0px",
            }
        );

        io.observe(clientContainer);
    });

})();
